import BaseDate from 'Component/common/base_date2';

function SubHead({ guideType, guide, baseDate, children }) {
  return (
    <div className="head">
      <div className="title">
        {children}
      </div>
      { baseDate && <BaseDate date={baseDate} /> }
    </div>
  )
}

export default SubHead;